export default __webpack_public_path__ + "static/media/nutrition_counselling.0cac0006.png";